import React from 'react';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import './SectionHeader.css';

function SectionHeader({ title, subtitle }) {
  const [ref, visible] = useScrollReveal(0.3);

  return (
    <div className={`section-header ${visible ? 'section-header--visible' : ''}`} ref={ref}>
      <h2 className="section-header__title">{title}</h2>
      <p className="section-header__subtitle">{subtitle}</p>
      <div className="section-header__divider" />
    </div>
  );
}

export default SectionHeader;
